import type { TreeDesignTokens, TreeTokenSections } from '@openng/optimus-ui-themes/types/tree';

export const nodeToggleButton: TreeTokenSections.NodeToggleButton = {
	borderRadius: '{tree.node.toggle.button.size} / 2',
};

export const filter: TreeTokenSections.Filter = {
	margin: '0.5rem',
};

export default {
	nodeToggleButton,
	filter,
} satisfies TreeDesignTokens;
